import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query SpaceRecordCount(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $filter: SpaceRecordsFilterInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordsCount(filter: $filter)
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceRecordCountQuery,
    number,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceRecordsCount',
                transformers.PASS_THROUGH,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  0,
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordCountQuery,
  number,
  graphql.schema.SpaceRecordCountQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
